import React from 'react';
import styles from './Pages.module.css';
import { Button } from 'antd';

import { useHistory, useRouteMatch } from 'react-router';
import { IState, IUser } from '../graphql/types';
import { batch, useDispatch, useSelector } from 'react-redux';
import usePlanSubscription from '../hooks/useSubscription/usePlanSubscription';
import {
  setNeedToRefetchSubData,
  setPaymentState,
  setUpgradeModalOpen,
} from '../actions';
import { PaymentState } from '../types';

const CustomPayment: React.FC = () => {
  const Paddle = window['Paddle'];
  const dispatch = useDispatch();
  const history = useHistory();
  const { path } = useRouteMatch();
  const { subscribe } = usePlanSubscription();

  const user = useSelector<IState, IUser | undefined>(state => state.user);

  React.useEffect(() => {
    if (
      user &&
      user.plan &&
      (user?.plan.versionID! === '1000' || user?.plan.versionID! === '1002')
    ) {
      history.push('/');
    }
  }, [user, history]);

  const handlePayment = () => e => {
    e.preventDefault();
    subscribe();
    Paddle.Checkout.open({
      product: path.includes('creator')
        ? process.env.REACT_APP_99_PLAN_ID
        : path.includes('plus-plan')
        ? process.env.REACT_APP_PLUS_PLAN_ID
        : process.env.REACT_APP_CUSTOM_PRO_ID,
      email: user?.email,
      passthrough: {
        userID: user?.userId,
        tenantID: user?.tenantID,
      },
      successCallback: () => {
        batch(() => {
          dispatch(setPaymentState(PaymentState.processing));
          dispatch(setNeedToRefetchSubData(true));
          dispatch(setUpgradeModalOpen(false));
        });
      },
    });
  };

  return (
    <main className={styles.customPayment}>
      <h1>
        {path.includes('plus-plan')
          ? 'Plus Plan (billed monthly)'
          : path.includes('creator')
          ? 'Custom Creator Plan (billed monthly)'
          : 'Custom Pro Plan (billed monthly)'}
      </h1>
      <Button onClick={handlePayment()}>Upgrade Now</Button>
    </main>
  );
};

export default CustomPayment;
